import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Promoc from "../../../component/promo/promoc.jsx";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import prmo from "../../../component/promo/promocard.json";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import hsimages from "../../../asset/hardsell/hsimages.js";
import data from "../../data.json";
import Heroimages from "../../../asset/hero/heroimages.js";
import fashankyu from "../../../asset/fascarousel/fas-hankyu/fas-hankyu.js";
import imghankyu5 from "../../../asset/imgrumah/img-hankyu/img-hankyu5.js";
import imghankyu6 from "../../../asset/imgrumah/img-hankyu/img-hankyu6.js";
import imghankyu7 from "../../../asset/imgrumah/img-hankyu/img-hankyu7.js";
import Cardprodukdetail1 from "../../../component/cardprodukdetail/cardprodukdetail1.jsx";
const imgMap = {
  fashankyu,
};
const imageMap = {
  imghankyu5,
  imghankyu6,
  imghankyu7,
};

const hankyu = () => {
  return (
    <div className="hankyu">
      <div className="hero">
        {data.hankyuab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.hankyuab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Hankyup.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasHankyu.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div className="produkcontainer">
        {dataproduk.hankyupr.map((card, index) => {
          return (
            <Cardprodukdetail1
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default hankyu;
